import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default class PinnedNav {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.wrapper = document.querySelector('[data-scrollwrapper]')
    this.links = this.el.querySelectorAll('[data-scrollto]')
    this.sections = document.querySelectorAll('[data-pinned-section]')
    this.footer = document.querySelector('[data-footer]')
  }

  init() {
    this.sections.forEach((item) =>
      this.addTimeline(item))
    if (this.wrapper) {
      this.handleNavFade()
    }
  }

  handleNavFade() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.wrapper,
        start: 'top-=100px top',
        end: 'bottom+=100px center',
        toggleActions: 'play reverse play reset',
      },
    })

    tl.to(this.el, {
      opacity: 1,
      duration: 0.3,
    })
  }

  addTimeline = (item) => {
    ScrollTrigger.create({
      trigger: item,
      start: 'top-=100px top',
      onUpdate: (self) => {
        this.handleUpdateActive(item)
      },
    })
  }

  handleUpdateActive(item) {
    const current = this.el.querySelector(
      `[data-scrollto="${item.dataset.pinnedSection}"]`,
    )
    this.links.forEach((item) =>
      item.classList.remove('s-active'))
    current.classList.add('s-active')
  }
}
